import React from 'react';
import { useState, useEffect } from 'react';
import Styled from 'styled-components';
import { Route, Switch, useHistory } from 'react-router-dom';
import TellUsAboutYourBusinessPlan from './TellUsAboutYourBusinessPlan';
import TellUsAboutYourBusinessForm from './TellUsAboutYourBusinessForm';
import TellUsAboutYourBusinessView from './TellUsAboutYourBusinessView';
import TellUsAboutYourBusinessSummary from './TellUsAboutYourBusinessSummary';
import WelcomeToDavie from '../../Components/WelcomeToDavie';
import usePost from '../../Hooks/usePost';
import useRequest from '../../Hooks/useRequest';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import StyledDrawer from '../../Components/Drawer';

const LoginContainer = Styled.div`
width: 100%;
height: 100%;
`;

const ConnectedTellUsAboutYourBusiness = () => {
    const [postData, setPostData] = useState({
        success: false,
        error: false,
        isLoading: false,
        message: [''],
    });

    const [selectedPriceData, setSelectedPriceData] = useState({
        nickname: '',
        priceId: '',
    });

    const { post } = usePost('/completeEnrollment');
    const { post: postCreateCustomer } = usePost('/stripe/createCustomer');
    const { post: postCreateSetupIntent } = usePost('/stripe/createSetupIntent');
    const { post: postUpdateCustomer } = usePost('/stripe/updateCustomer');
    const { post: postCreateSubscription } = usePost('/stripe/createASubscription');

    const history = useHistory();
    const { data: planTypeData } = useRequest('/getAllPlans');
    const { data: priceData } = useRequest('/stripe/getAllPrices');

    const [aboutYourBusinessData, setAboutYourBusinessData] = useState({
        companyName: '',
        companyWebsite: '',
        firstName: '',
        lastName: '',
        title: '',
        primaryPhone: '',
        mobilePhone: '',
        streetAddress: '',
        email: '',
        secondaryAddress: '',
        additionalAddress: [],
        city: '',
        state: '',
        country: '',
        zipCode: '',
        accountType: '',
        planTypeId: '',
        planTypeName: '',
        planTypeDuration: '',
        planTypePrice: '',
        billingName: '',
        billingStreetAddress: '',
        billingCountry: '',
        billingCity: '',
        billingZipCode: '',
        billingStateOrProvince: '',
        billingTermsIsChecked: false,
    });

    const {
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        email,
        city,
        state,
        country,
        zipCode,
        accountType,
        planTypeId,
        planTypeDuration,
    } = { ...aboutYourBusinessData };

    const planTypeNameLocal = localStorage.getItem('planTypeName');
    const planTypeIdLocal = localStorage.getItem('planTypeId');
    const planTypePriceLocal = localStorage.getItem('planTypePrice');
    const planTypeDurationLocal = localStorage.getItem('planTypeDuration');

    useEffect(() => {
        setAboutYourBusinessData({
            ...aboutYourBusinessData,
            planTypeId: planTypeIdLocal,
            planTypeName: planTypeNameLocal,
            planTypeDuration: planTypeDurationLocal,
            planTypePrice: planTypePriceLocal,
        });
    }, [planTypeIdLocal, planTypeNameLocal, planTypePriceLocal, planTypeDurationLocal]);

    const determinePriceId = () => {
        const priceDataArray = priceData?.data;
        priceDataArray?.map((item) => {
            const priceDataNickname = item?.nickname?.split(' ')[0];
            const priceDataDuration = item?.nickname?.split(' ')[1];

            if (
                priceDataNickname?.toLowerCase() === planTypeNameLocal?.toLowerCase() &&
                priceDataDuration?.toLowerCase() === planTypeDurationLocal?.toLowerCase()
            ) {
                setSelectedPriceData({ nickname: item.nickname, priceId: item.id });
            }
            return null;
        });
    };

    useEffect(() => {
        determinePriceId();
    }, [priceData, planTypeNameLocal]);

    const createNewAdvertiser = async (stripeCustomerId) => {
        if (stripeCustomerId) {
            const body = {
                isAgency: accountType === 'Agency' ? true : false,
                companyName,
                companyWebsite,
                firstName,
                lastName,
                title,
                primaryPhone,
                mobilePhone,
                streetAddress,
                country,
                city,
                province: state,
                zipCode,
                planTypeId: parseInt(planTypeId),
                stripeCustomerId,
                isBilledAnually: planTypeDuration === 'Anually' ? true : false,
            };

            try {
                setPostData({ error: false, success: false, isLoading: true });
                const resp = await post(body, 'POST');
                if (resp) {
                    setPostData({
                        ...postData,
                        success: true,
                        message: ['Advertiser Created Succesfully!'],
                    });
                    localStorage.setItem('firstTimeSignIn', true);
                    window.location.reload();
                }
            } catch (err) {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Advertiser Creation Failed, something went wrong'],
                });
            }
        } else {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Error: No customer Id created for this user, please try again.'],
            });
        }
    };

    const stripe = useStripe();
    const elements = useElements();

    const createACustomer = async () => {
        try {
            setPostData({ error: false, success: false, isLoading: true });
            //create a customer
            const createCustomerResp = await postCreateCustomer(
                {
                    address: {
                        city: city,
                        country: country,
                        line1: streetAddress,
                        postal_code: zipCode,
                        state: state,
                    },
                    shipping: {
                        address: {
                            city: city,
                            country: country,
                            line1: streetAddress,
                            postal_code: zipCode,
                            state: state,
                        },
                        name: `${firstName} ${lastName}`,
                        phone: mobilePhone,
                    },
                    description: 'Customer Created For Davie',
                    email: email,
                    name: `${firstName} ${lastName}`,
                    phone: mobilePhone,
                },
                'POST'
            );
            const { id: customerId } = createCustomerResp.data;
            if (customerId) {
                //create paymentMethod
                const { paymentMethod } = await stripe.createPaymentMethod({
                    type: 'card',
                    card: elements.getElement(CardElement),
                });
                const { id: paymentMethodId } = paymentMethod;

                if (paymentMethodId) {
                    //attach payment methodID to setup Intent
                    const setupIntentResp = await postCreateSetupIntent(
                        {
                            confirm: true,
                            customerId,
                            description: 'Create setup intent for davie',
                            paymentMethodId,
                        },
                        'POST'
                    );

                    const { id: setupIntentId } = setupIntentResp.data;

                    if (setupIntentId) {
                        // if setup Intent created, update customer default payment Method
                        const updateCustomerResp = await postUpdateCustomer(
                            {
                                invoice_settings: {
                                    default_payment_method: paymentMethodId,
                                },
                            },
                            'POST',
                            customerId
                        );
                        const { id: updatedCustomerId } = updateCustomerResp.data;
                        if (updatedCustomerId) {
                            //if customer has been updated create subscription
                            const createASubscriptionResp = await postCreateSubscription(
                                {
                                    customerId: customerId,
                                    description: selectedPriceData.nickname,
                                    items: [
                                        {
                                            priceId: selectedPriceData.priceId,
                                        },
                                    ],
                                },
                                'POST'
                            );
                            const { id: createdSubscriptionId } = createASubscriptionResp.data;
                            if (createdSubscriptionId) {
                                //customer subscriped succesfully, create advertiser
                                createNewAdvertiser(updatedCustomerId);
                            } else {
                                setPostData({
                                    error: true,
                                    success: false,
                                    isLoading: false,
                                    message: ['Subscription Creation failed, Please try again.'],
                                });
                            }
                        } else {
                            setPostData({
                                error: true,
                                success: false,
                                isLoading: false,
                                message: ['Update Customer failed, Please try again.'],
                            });
                        }
                    } else {
                        setPostData({
                            error: true,
                            success: false,
                            isLoading: false,
                            message: ['Setup Intent failed, Please try again.'],
                        });
                    }
                } else {
                    setPostData({
                        error: true,
                        success: false,
                        isLoading: false,
                        message: ['Failed to create payment method.'],
                    });
                }
            } else {
                setPostData({
                    error: true,
                    success: false,
                    isLoading: false,
                    message: ['Failed to create customer.'],
                });
            }
        } catch (err) {
            setPostData({
                error: true,
                success: false,
                isLoading: false,
                message: ['Failed to communicate with stripe, Please try again later.'],
            });
        }
    };

    return (
        <LoginContainer>
            <div style={{ right: 30, top: 150, position: 'absolute' }}>
                <StyledDrawer />
            </div>
            <WelcomeToDavie />
            <Switch>
                <Route path="/aboutYourBusiness/plan">
                    <TellUsAboutYourBusinessPlan
                        setAboutYourBusinessData={setAboutYourBusinessData}
                        aboutYourBusinessData={aboutYourBusinessData}
                        history={history}
                        planTypeData={planTypeData}
                    />
                </Route>
                <Route path="/aboutYourBusiness/form">
                    <TellUsAboutYourBusinessForm
                        setAboutYourBusinessData={setAboutYourBusinessData}
                        aboutYourBusinessData={aboutYourBusinessData}
                        history={history}
                        planTypeData={planTypeData}
                    />
                </Route>
                <Route path="/aboutYourBusiness/view">
                    <TellUsAboutYourBusinessView
                        history={history}
                        aboutYourBusinessData={aboutYourBusinessData}
                        setAboutYourBusinessData={setAboutYourBusinessData}
                        createNewAdvertiser={createNewAdvertiser}
                        createACustomer={() => createACustomer}
                        setPostData={setPostData}
                        postData={postData}
                    />
                </Route>
                <Route path="/aboutYourBusiness/summary">
                    <TellUsAboutYourBusinessSummary />
                </Route>
            </Switch>
        </LoginContainer>
    );
};
export default ConnectedTellUsAboutYourBusiness;
